// src/stone/icons/FinanceAndStone.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var FinanceAndStone = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 40 40",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { fill: "currentcolor", d: "M20.947 8.52v22.96h-2V8.52z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "currentcolor",
          d: "M18.983 10.753c2.377-.17 5.092.44 6.499 1.212l.876.482-.963 1.753-.877-.482c-1.02-.561-3.34-1.117-5.392-.97-1.018.073-1.844.312-2.389.696-.492.347-.808.843-.808 1.663 0 1.008.412 1.636 1.108 2.146.762.56 1.823.941 3.062 1.354l.257.086c1.102.365 2.34.775 3.305 1.397 1.112.717 1.975 1.787 1.975 3.43 0 1.45-.481 2.613-1.367 3.45-.859.813-2.004 1.229-3.185 1.406-2.348.352-5.195-.185-7.465-1.004l-.94-.34.678-1.88.94.339c2.1.757 4.592 1.192 6.49.907.942-.141 1.648-.446 2.108-.88.434-.411.741-1.022.741-1.999 0-.784-.35-1.291-1.058-1.748-.743-.478-1.748-.813-2.936-1.208l-.176-.059c-1.188-.396-2.555-.863-3.612-1.638-1.125-.825-1.925-2.017-1.925-3.76 0-1.477.638-2.58 1.656-3.296.963-.68 2.2-.97 3.398-1.057"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "currentcolor",
          d: "m20 .645 17.667 3.701V22.62c0 4.452-1.877 8.71-5.196 11.839-3.317 3.127-7.804 4.875-12.471 4.875s-9.154-1.748-12.471-4.875c-3.32-3.13-5.196-7.387-5.196-11.84V4.347zM4.333 5.97v16.648c0 3.883 1.636 7.62 4.568 10.384 2.934 2.766 6.926 4.33 11.099 4.33s8.165-1.564 11.099-4.33c2.932-2.765 4.568-6.501 4.568-10.384V5.97L20 2.688z"
        }
      )
    ]
  }
);
var FinanceAndStone_default = FinanceAndStone;

export {
  FinanceAndStone_default
};
